import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy } from 'react';

const LazyWorksToCheck = lazy(() =>
  import('./worksToCheck')
    .then((module) => ({ default: module.WorksToCheck }))
    .catch(() => {
      document.location.reload();
      return { default: () => <></> };
    })
);

export const WorksToCheck = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyWorksToCheck />
  </Suspense>
);
